import {Component} from '@angular/core';
import {EmployeesEditHistoryCacheService} from './core/employee-edit-history-cache.service';
import {TimecardBuilderService} from './reports/timecards-builder.service';
import {employeeEditHistoryResourceFactory} from './settings/settings.module';

@Component({
	selector: 'tt-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
	providers: [
		TimecardBuilderService,
		{
			provide: 'EmployeeEditHistoryResource',
			useFactory: employeeEditHistoryResourceFactory,
			deps: []
		}
	]
})
export class AppComponent {

	constructor(
		private employeeEditHistoryCacheService: EmployeesEditHistoryCacheService,
		private timecardBuilderService: TimecardBuilderService
	) {
	}
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts